import { mutatorAction } from 'satcheljs';
import type ItemPartViewState from 'owa-mail-reading-pane-store/lib/store/schema/ItemPartViewState';

export const expandCollapseFossilizedTextMutator: (
    itemPart: ItemPartViewState,
    shouldExpand: boolean
) => void = mutatorAction(
    'expandCollapseFossilizedTextMutator',
    (itemPart: ItemPartViewState, shouldExpand: boolean): void => {
        itemPart.isFossilizedTextExpanded = shouldExpand;
    }
);
